// removed by extract-text-webpack-plugin
module.exports = {"btn":"_2Y7KWuJt0SS5q3LqXmxyuj","inline":"_1_R52eU4wq3MPWan3Md1V8","primary":"ryfwJXy0hcHrtWV4VrvTN","secondary":"_12esCcMtYcuXuq8RL0zX_L","spacing-mid":"_8P3dW0WaS_WfN3qadKlzY"};


//////////////////
// WEBPACK FOOTER
// ./src/v2SPRINTA/atoms/Button/style.module.css
// module id = 450
// module chunks = 37